import { HighlightOff } from '@mui/icons-material';

// פופאפ ביניים שנפתח בלחיצה על "החלף מועד" כשגם "עכשיו" וגם "הזמנה עתידית"
// אפשריים לערוץ הנוכחי - שאלה מפורשת לפני שממשיכים לבורר תאריך/שעה.
// props: onNow() - נבחר "שלחו לי עכשיו", onFuture() - נבחר "הזמנה עתידית", onClose()
const SwitchNowOrFuturePopup = (props) => {

    return (
        <div className={"futureTimePopupOverlay"} onClick={() => props.onClose()}>
            <div className={"futureTimePopupInner"} onClick={(e) => e.stopPropagation()}>
                <button type="button" className={"btnReset sideClosBtn halfspin"} aria-label="סגור"
                    onClick={() => props.onClose()}>
                    <HighlightOff aria-hidden="true" />
                </button>
                <div className={"futurePickerTitle bold centerText"}>מתי תרצו את ההזמנה?</div>
                <button type="button" className={"btnReset selectOpBtn futureContinueBtn"}
                    onClick={() => props.onNow()}>
                    לעכשיו
                </button>
                <button type="button" className={"btnReset selectOpBtn futureContinueBtn"}
                    onClick={() => props.onFuture()}>
                    הזמנה עתידית
                </button>
            </div>
        </div>
    );
}

export default SwitchNowOrFuturePopup;
